import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { handlePutRequest } from "../../services/PutTemplate";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { handleGetRequest } from "../../services/GetTemplate";
import Loading from "../../components/Loader";
import classNames from "classnames";
import SecuredFileChange from "../../components/SecuredFileChange/SecuredFileChange";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { Dialog } from "primereact";
import { Carousel } from "primereact/carousel";
import baseURL, { endPoints } from "../../Config";

const EditViewVariant = ({ onHide, getVariantList, variantdataId, isEditable }) => {
    const dispatch = useDispatch();
    const [model, setVehicleModel] = useState([]);
    const [category, setCategory] = useState([]);
    const [transmission, setTransmission] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [maker, setMaker] = useState([]);
    const [powerType, setPowerType] = useState([]);
    const [featureList, setFeatureList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedFileError, setSelectedFileError] = useState(null);
    const [selectedFileArray, setSelectedFileArray] = useState([]);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [displayImageDialog, setDisplayImageDialog] = useState(false);
    const [partList, setPartList] = useState([]);
    const [selectedParts, setSelectedParts] = useState([]);


    const variantImageRef = useRef(null);

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            ?.matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .required("This field is required"),
        makerId: Yup.string().required("This field is required"),
        modelId: Yup.string().required("This field is required"),
        categoryId: Yup.string().required("This field is required"),
        transmissionId: Yup.string().required("This field is required"),
        yearId: Yup.string().required("This field is required").nullable(),
        powerTypeId: Yup.string().required("This field is required"),
        cost: Yup.number().nullable(),
        currencyCode: Yup.string().when("cost", {
            is: (cost) => cost !== undefined && cost !== null && cost !== "",
            then: Yup.string().required("Please select currency"),
            otherwise: Yup.string(),
        }),
        mileage: Yup.number().nullable(),
        mileageUnit: Yup.string().when("mileage", {
            is: (mileage) => mileage !== undefined && mileage !== null && mileage !== "",
            then: Yup.string().required("Please select milage unit"),
            otherwise: Yup.string(),
        }),
        images: Yup.string().when([], {
            is: () => selectedFileArray.length === 0,
            then: Yup.string().required("You must upload at least one image"),
            otherwise: Yup.string(),
        }),
    });
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            variantId: "",
            name: "",
            modelId: "",
            cost: "",
            currencyCode: "AED",
            feature: [],
            categoryId: "",
            transmissionId: "",
            yearId: "",
            makerId: "",
            powerTypeId: "",
            images: "",
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);
            const newBase64Array = selectedFileArray.filter((item) => item.startsWith("data:image"));
            const updatedSelectedFileArray = selectedFileArray.filter((item) => !item.startsWith("data:image")).map((url) => url.replace(`${baseURL}/`, ""));

            let obj = {
                variantId: data?.variantId,
                name: data?.name,
                modelId: data?.modelId,
                cost: data?.cost ? data?.cost : undefined,
                currencyCode: data?.currencyCode ? data?.currencyCode?.toString() : undefined,
                feature: data?.feature && data.feature.length > 0 ? data.feature.join(",") : undefined,
                categoryId: data?.categoryId,
                transmissionId: data?.transmissionId,
                yearId: new Date(data?.yearId).getFullYear(),
                makerId: data?.makerId,
                powerTypeId: data?.powerTypeId,
                newVariantImages: newBase64Array ? newBase64Array : null,
                oldVariantImages: updatedSelectedFileArray ? updatedSelectedFileArray : null,
                parts: selectedParts,
            };

            const response = await dispatch(handlePutRequest(obj, endPoints.updateVariant(data?.variantId), false, true));
            if (response?.statusCode === 200) {
                getVariantList();
                onHide();
            }
            setLoadingBtn(false);
        },
    });

    const getMaker = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getMakersDropdown, false));
        if (response) {
            setMaker(response?.data);
        }
    };

    const getCategory = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getCategoriesDropdown, false));
        if (response) {
            setCategory(response?.data);
        }
    };

    const getVehiclemodel = async () => {
        const filter = [];
        if (formik?.values?.makerId) {
            filter.push(`makerId=${formik?.values?.makerId}`);
        }
        if (formik?.values?.categoryId) {
            filter.push(`categoryId=${formik?.values?.categoryId}`);
        }
        const filterString = filter.join("&");
        const response = await dispatch(handleGetRequest(endPoints.getModelsDropdown(filterString), false));
        if (response) {
            setVehicleModel(response?.data);
        }
    };

    const gettransmission = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getTransmissionsDropdown, false));
        if (response) {
            setTransmission(response?.data);
        }
    };

    const getCurrencies = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getCurrenciesDropdown, false));
        if (response) {
            setCurrencies(response?.data);
        }
    };

    const getPowerType = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getPowerTypeDropdown, true));
        if (response) {
            setPowerType(response?.data);
        }
    };

    const getFeatureList = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getAllFeatures, false));
        if (response) {
            setFeatureList(response?.data);
        }
    };
    const getPartList = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getCategoriesWiseParts, false));

        if (response.statusCode == "200") {
            setPartList(response?.data);
        }
    };

    useEffect(() => {
        getCategory();
        gettransmission();
        getCurrencies();
        getMaker();
        getPowerType();
        getFeatureList();
        getPartList();
    }, []);

    useEffect(() => {
        if (formik?.values?.makerId != "" && formik?.values?.categoryId != "") {
            getVehiclemodel();
        }
    }, [formik?.values?.makerId, formik?.values?.categoryId]);

    const handleSelectionChange = (categoryId, selectedValues) => {
        // Preserve partId for previously selected parts coming from API; assign 0 for newly added
        const newSelections = selectedValues.map((part) => {
            const existing = selectedParts.find((p) => p.partCategoryId === categoryId && p.partName === part.partName);

            return {
                partId: existing ? existing.partId : 0,
                partName: part.partName,
                partCategoryId: categoryId,
                partImage: part.imageUrl || "",
            };
        });

        // Remove any previous selections for this category, then merge the updated ones
        const filtered = selectedParts.filter((p) => p.partCategoryId !== categoryId);

        setSelectedParts([...filtered, ...newSelections]);
    };

    const getSelectedValues = (categoryId) => {
        const selectedPartNames = selectedParts.filter((p) => p.partCategoryId === categoryId).map((p) => p.partName);

        const category = partList.find((cat) => cat.partCategoryId === categoryId);

        if (!category) return [];

        return (category.masterParts || []).filter((part) => selectedPartNames.includes(part.partName));
    };

    const getVariantById = async () => {
        setLoading(true);
        const response = await dispatch(handleGetRequest(endPoints.getVariantById(variantdataId), false));
        if (response) {
            const keyData = response?.data;
            formik.setFieldValue("variantId", keyData?.id);
            formik.setFieldValue("name", keyData?.variantName);
            formik.setFieldValue("makerId", keyData?.makerId?.toString());
            formik.setFieldValue("categoryId", keyData?.categoryId?.toString());
            formik.setFieldValue("modelId", keyData?.variantModelId?.toString());
            formik.setFieldValue("transmissionId", keyData?.variantTransmissionId?.toString());
            formik.setFieldValue("yearId", new Date(`${keyData?.year}-12-31T00:00:00.000Z`));
            formik.setFieldValue("feature", keyData?.feature?.toString() ? keyData.feature.split(",").map((item) => item.trim()) : []);
            formik.setFieldValue("cost", keyData?.cost);
            formik.setFieldValue("currencyCode", keyData?.currencyCode?.toString());
            formik.setFieldValue("powerTypeId", keyData?.variantPowerTypeId?.toString());

            setSelectedParts((prev) => [
                ...prev,
                ...keyData?.groupedParts.flatMap((category) =>
                    category.parts.map((part) => ({
                        partCategoryId: category.partCategoryId,
                        partName: part.partName,
                        partId: part.partId,
                        partImage: part.partImg,
                    }))
                ),
            ]);

            setSelectedFileArray(
                keyData?.variantImages?.map((item) => {
                    return `${baseURL}/${item}`;
                }) ?? []
            );
        }
        setLoading(false);
    };

    useEffect(() => {
        if (variantdataId) {
            getVariantById();
        }
    }, [variantdataId]);

    const handleDeleteImage = (index) => {
        setSelectedFileArray((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const previewImage = () => {
        setDisplayImageDialog(true);
    };

    const closeDisplayDialog = () => {
        setDisplayImageDialog(false);
    };
    const imagePreviewer = (file) => {
        return (
            <div className="p-field col-12 md:col-12">
                <img src={file} style={{ maxWidth: "100%", maxHeight: "100%", width: "900px", height: "500px", objectFit: "contain" }} />
            </div>
        );
    };
    const responsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 3,
            numScroll: 3,
        },
    ];

    const handleVehicleIcon = () => {
        variantImageRef.current.click();
    };

    // for multiple image upload
    function handleVariantImageChange(event) {
        setSelectedFileError("");
        if (selectedFileArray?.length >= 6) {
            setSelectedFileError("You can only upload a maximum of 6 images.");
            return;
        }
        const selectedFile = event.target.files[0];
        const fileTypes = ["image"];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
            setSelectedFileError(error);
        } else if (newFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setSelectedFileArray((prevItems) => [...prevItems, base64String]);
            };
            reader.readAsDataURL(newFile);
        }
    }

    const currentYear = new Date().getFullYear();
    const maxDate = new Date(currentYear, 11, 31);

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    console.log("formik.values", formik.errors);

    return (
        <>
            <Dialog visible={displayImageDialog} blockScroll style={{ width: "50vw" }} maskClassName="zindex9999" onHide={() => closeDisplayDialog()} draggable={false}>
                {selectedFileArray.length > 1 ? (
                    <Carousel value={selectedFileArray || []} numVisible={1} numScroll={1} responsiveOptions={responsiveOptions} className="custom-carousel" circular={false} itemTemplate={imagePreviewer} />
                ) : (
                    <img src={selectedFileArray[0]} style={{ maxWidth: "100%", maxHeight: "100%", width: "900px", height: "500px", objectFit: "contain" }} />
                )}
            </Dialog>
            {loading ? <Loading /> : <></>}
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid pl-2 pr-2">
                    <div className="field col-12 md:col-6">
                        <label> Variant </label>
                        <span className="Label__Required">*</span>
                        <InputText placeholder="Enter Variant Name" className={classNames({ "p-invalid": isFormFieldValid("name") }, "Input__Round")} id="name" name="name" type="text" maxLength={50} value={formik.values.name} onChange={formik.handleChange} disabled={!isEditable} />
                        {getFormErrorMessage("name")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Maker </label>
                        <span className="Label__Required">*</span>
                        <Dropdown
                            placeholder="Select Maker"
                            className={classNames({ "p-invalid": isFormFieldValid("makerId") }, "Dropdown__Round")}
                            id="makerId"
                            name="makerId"
                            options={maker}
                            optionValue="id"
                            optionLabel="name"
                            value={formik.values.makerId}
                            filter
                            showClear={!!formik?.values?.makerId}
                            filterBy="model_name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("makerId", e.target.value ? e.target.value : "");
                            }}
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("makerId")}
                    </div>{" "}
                    <div className="field col-12 md:col-6">
                        <label> Category </label>
                        <span className="Label__Required">*</span>
                        <Dropdown
                            placeholder="Select Category"
                            className={classNames({ "p-invalid": isFormFieldValid("categoryId") }, "Dropdown__Round")}
                            id="categoryId"
                            name="categoryId"
                            options={category}
                            optionValue="id"
                            optionLabel="name"
                            value={formik.values.categoryId}
                            filter
                            showClear={!!formik?.values?.categoryId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("categoryId", e.target.value ? e.target.value : "");
                            }}
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("categoryId")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Vehicle Model </label>
                        <span className="Label__Required">*</span>
                        <Dropdown
                            placeholder="Select Vehicle Model"
                            className={classNames({ "p-invalid": isFormFieldValid("modelId") }, "Dropdown__Round")}
                            id="modelId"
                            name="modelId"
                            options={model}
                            optionValue="id"
                            optionLabel="name"
                            value={formik.values.modelId}
                            filter
                            showClear={!!formik?.values?.modelId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("modelId", e.target.value ? e.target.value : "");
                            }}
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("modelId")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Transmission </label>
                        <span className="Label__Required">*</span>
                        <Dropdown
                            placeholder="Select Transmission"
                            className={classNames({ "p-invalid": isFormFieldValid("transmissionId") }, "Dropdown__Round")}
                            id="transmissionId"
                            name="transmissionId"
                            options={transmission}
                            optionValue="id"
                            optionLabel="name"
                            value={formik.values.transmissionId}
                            filter
                            showClear={!!formik?.values?.transmissionId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("transmissionId", e.target.value ? e.target.value : "");
                            }}
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("transmissionId")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="yearId"> Year </label>
                        <span className="Label__Required">*</span>
                        <Calendar
                            id="yearId"
                            name="yearId"
                            value={formik.values.yearId}
                            onChange={formik.handleChange}
                            view="year"
                            dateFormat="yy"
                            maxDate={maxDate}
                            placeholder="Select Year"
                            className={classNames({ "p-invalid": isFormFieldValid("yearId") }, "Dropdown__Round")}
                            disabled={!isEditable}
                        />

                        {getFormErrorMessage("yearId")}
                    </div>{" "}
                    <div className="field col-12 md:col-6">
                        <label> Power Type </label>
                        <span className="Label__Required">*</span>
                        <Dropdown
                            placeholder="Select Power Type"
                            className={classNames({ "p-invalid": isFormFieldValid("powerTypeId") }, "Dropdown__Round")}
                            id="powerTypeId"
                            name="powerTypeId"
                            options={powerType}
                            optionValue="id"
                            optionLabel="name"
                            value={formik.values.powerTypeId}
                            filter
                            showClear={!!formik?.values?.powerTypeId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("powerTypeId", e.target.value ? e.target.value : "");
                            }}
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("powerTypeId")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Feature </label>
                        <span className="Label__Required"></span>{" "}
                        <MultiSelect
                            display="chip"
                            placeholder="Select Features"
                            className={classNames({ "p-invalid": isFormFieldValid("feature") }, "Dropdown__Round Multiselect__Dropdown")}
                            id="feature"
                            name="feature"
                            options={featureList}
                            optionValue="name"
                            optionLabel="name"
                            value={formik.values.feature}
                            filter
                            showClear={!!formik?.values?.feature}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("feature", e.target.value ? e.target.value : "");
                            }}
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("feature")}
                    </div>{" "}
                    <div className="flex field col-12 md:col-6">
                        <div className="field col-12 md:col-6 ">
                            <label> Price </label>
                            <span className="Label__Required"></span>
                            <InputText
                                keyfilter={/^[0-9]*(\.[0-9]*)?$/}
                                className={classNames({ "p-invalid": isFormFieldValid("cost") }, "Input__Round")}
                                id="cost"
                                maxLength={8}
                                name="cost"
                                type="text"
                                value={formik.values.cost}
                                onChange={formik.handleChange}
                                placeholder="Enter Price"
                                disabled={!isEditable}
                            />
                            {getFormErrorMessage("cost")}
                        </div>{" "}
                        <div className="field col-12 md:col-6 ml-0">
                            <label> Currency </label>
                            <span className="Label__Required"></span>
                            <Dropdown
                                placeholder="Select CurrencyCode"
                                className={classNames({ "p-invalid": isFormFieldValid("currencyCode") }, "Dropdown__Round")}
                                id="currencyCode"
                                name="currencyCode"
                                options={currencies}
                                optionValue="name"
                                optionLabel="name"
                                value={formik.values.currencyCode}
                                filter
                                showClear={!!formik?.values?.currencyCode}
                                filterBy="name"
                                showFilterClear={true}
                                resetFilterOnHide={true}
                                onChange={(e) => {
                                    formik?.setFieldValue("currencyCode", e.target.value ? e.target.value : "");
                                }}
                                disabled={!isEditable}
                            />
                            {getFormErrorMessage("currencyCode")}
                        </div>
                    </div>
                    {isEditable && (
                        <div className="field col-12 md:col-6">
                            <label> Upload Images </label> <span className="Label__Required">*</span>
                            <div className="file-input-container " onClick={handleVehicleIcon}>
                                <input type="file" accept="image/*" style={{ display: "none" }} ref={variantImageRef} onChange={handleVariantImageChange} disabled={!isEditable || selectedFileArray?.length >= 6} />
                                <input className={classNames({ "p-invalid": isFormFieldValid("images") }, "custom-file p-inputtext p-component Input__Round")} type="text" placeholder="Choose a file..." value={formik.values.images} readOnly disabled={!isEditable || selectedFileArray?.length >= 6} />
                                <span className="file-upload-icon">
                                    <i className="pi pi-paperclip" />
                                </span>
                            </div>
                            {selectedFileError ? <small className="p-error">{selectedFileError}</small> : getFormErrorMessage("images")}
                        </div>
                    )}{" "}
                    <div className="field col-12 md:col-12">
                        <div>
                            <label> Uploaded Images </label>
                        </div>
                        <div className=" border-solid border-900 border-2 border-round p-5 mt-2">
                            {selectedFileArray.map((item, index) => {
                                return (
                                    <div key={index} style={{ position: "relative", display: "inline-block", margin: "5px", width: "110px", height: "110px" }}>
                                        {isEditable ? <i className="pi pi-times closingIcon" onClick={() => handleDeleteImage(index)} style={{ cursor: "pointer", position: "absolute", top: "0", right: "0" }} /> : ""}
                                        <img
                                            src={item}
                                            style={{ width: "90px", height: "90px", objectFit: "contain" }}
                                            alt="Variant Image"
                                            onClick={() => {
                                                previewImage();
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {partList &&
                        partList?.map((category) => (
                            <div key={category.partCategoryId} className="field col-12 md:col-3">
                                <label>{category.partCategoryName}</label>
                                <span className="Label__Required"></span>
                                <MultiSelect
                                    placeholder="Select"
                                    className={classNames({ "p-invalid": isFormFieldValid(category.partCategoryName) }, "MultiSelect__Round")}
                                    id={category.partCategoryName}
                                    name={category.partCategoryName}
                                    options={category.masterParts || []}
                                    optionLabel="partName"
                                    value={getSelectedValues(category.partCategoryId)}
                                    filter
                                    filterBy="partName"
                                    showFilterClear={true}
                                    resetFilterOnHide={true}
                                    onChange={(e) => handleSelectionChange(category.partCategoryId, e.target.value)}
                                    disabled={!isEditable}
                                />
                                {getFormErrorMessage(category.partCategoryName)}
                            </div>
                        ))}
                    <div className="col-12 d-flex flex-row text-center mt-4 pb-2">
                        <Button className="Cancel-Button" label="Cancel" type="button" onClick={onHide} />
                        {isEditable === true && <Button className="Save-Button ml-2" label="Update" type="submit" loading={loadingBtn} />}
                    </div>
                </div>
            </form>
        </>
    );
};

export default EditViewVariant;
